export default __webpack_public_path__ + "static/tip4-fcfede6aebf484c5c80082202be6abd1.png";